// extracted by mini-css-extract-plugin
export var avatarContainer = "_s-0";
export var avatarTypingWave = "_s-i";
export var gray = "_s-f";
export var green = "_s-c";
export var icon = "_s-9";
export var image = "_s-1";
export var lg = "_s-6";
export var md = "_s-5";
export var presenceDot = "_s-b";
export var red = "_s-d";
export var sm = "_s-4";
export var status = "_s-a";
export var typingDot = "_s-h";
export var typingPill = "_s-g";
export var xl = "_s-7";
export var xs = "_s-3";
export var xxl = "_s-8";
export var xxs = "_s-2";
export var yellow = "_s-e";